import { Css, ResponsiveGridConfig, useResponsiveGrid, useResponsiveGridItem } from "@homebound/beam";
import { mergeProps } from "@react-aria/utils";
import { QueryTable } from "src/components";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useProjectDashboardFinancialsQuery } from "src/routes/projects/dashboard/components/Financials/ProjectDashboardFinancials.generated";
import {
  createFinancialsTableColumns,
  createFinancialsTableRows,
} from "src/routes/projects/dashboard/components/Financials/utils";
import { RecentActivityRail } from "src/routes/projects/dashboard/components/RecentActivityRail/RecentActivityRail";

export function FinancialsTab() {
  const { projectId } = useRouteParams<{ projectId: string }>();
  const query = useProjectDashboardFinancialsQuery({ variables: { projectId } });
  const gridConfig: ResponsiveGridConfig = { minColumnWidth: 276, columns: 4, gap: 24 };
  const { gridStyles } = useResponsiveGrid(gridConfig);
  const { gridItemProps, gridItemStyles } = useResponsiveGridItem({ colSpan: 3, gridConfig });

  return (
    <div css={{ ...gridStyles, ...Css.aifs.$ }}>
      <div {...mergeProps(gridItemProps, Css.props({ ...Css.bgWhite.p3.br8.bshBasic.$, ...gridItemStyles }))}>
        <h2 css={Css.xl.$}>Financial Summary</h2>
        <QueryTable
          query={query}
          createRows={createFinancialsTableRows}
          columns={createFinancialsTableColumns()}
          style={{ allWhite: true, cellTypography: "sm" }}
        />
      </div>

      <RecentActivityRail />
    </div>
  );
}
